import React, { useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { format } from 'date-fns';
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from '@material-ui/pickers';
import {
  Button,
  Collapse,
  Divider,
  Icon,
  IconButton,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography
} from '@material-ui/core';
import { subscriptionStatus } from 'helpers/customerSubscriptions';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';


export const HistoryFilterDrawer = ({setOpenFilter, setFilterConditions, filterConditions}) => {
  const [expandedSubscriptionStatus, toggleExpandedSubscriptionStatus] = useState(false);
  const [expandedCreated, toggleExpandedCreated] = useState(false);
  const [conditions, setConditions] = useState({
    created_from: {
      field: 'created_at',
      value: filterConditions.created_from?.value || '',
      conditionType: 'gt'
    },
    created_to: {
      field: 'created_at',
      value: filterConditions.created_to?.value || '',
      conditionType: 'lt'
    },
    status: {
      field: 'status',
      value: filterConditions.status?.value || '',
      conditionType: 'eq'
    },
  });

  const setConvertedDate = (value) => {
    const date = new Date(value);
    return date.toUTCString();
  };

  const handleClearDate = (event, name) => {
    event.preventDefault();
    event.stopPropagation();
    setConditions({
      ...conditions,
      [name]: {
        ...conditions['created_from'],
        value: ''
      }
    });
  };

  const handleChangeFilter = (field, value, conditionType, name) => {
    setConditions((conditions) => (
      {
        ...conditions,
        [name]: {
          field,
          value,
          conditionType
        }
      }
    ));
  };

  const handleApplyFilter = () => {
    setFilterConditions(conditions);
    setOpenFilter(false);
  };

  const isCreateAtError = conditions?.created_to.value !== '' && conditions?.created_to.value < conditions?.created_from?.value;

  return (
    <div className="px-4 pt-4 min-h-full-screen flex-column justify-between">
      <div>
        <div className="flex items-center justify-between mb-2">
          <Typography variant="h5" className="text-primary uppercase">Filter by:</Typography>
          <IconButton onClick={() => setOpenFilter(false)}>
            <Icon fontSize="small">close</Icon>
          </IconButton>
        </div>
        <div>
          <Divider className="my-5" />
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => toggleExpandedSubscriptionStatus((expandedSubscriptionStatus) => !expandedSubscriptionStatus)}
          >
            <Typography variant="h6">Status</Typography>
            {expandedSubscriptionStatus ? <ExpandLess /> : <ExpandMore />}
          </div>
          <Collapse in={expandedSubscriptionStatus} timeout="auto">
            <FormControl component="div">
              <RadioGroup
                aria-label="status"
                name="status"
                value={conditions?.status?.value || ''}
                onChange={({target: {value, name}}) => handleChangeFilter(name, value, 'eq', name)}
              >
                {Object.keys(subscriptionStatus).map((status) => (
                  <FormControlLabel
                    key={`history-status-${status}`}
                    value={status}
                    control={<Radio color="primary" size="small" />}
                    label={subscriptionStatus[status]}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Collapse>
          <Divider className="my-5" />
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => toggleExpandedCreated((expandedDate) => !expandedDate)}
          >
            <Typography variant="h6">Date</Typography>
            {expandedCreated ? <ExpandLess /> : <ExpandMore />}
          </div>
          <Collapse in={expandedCreated} timeout="auto">
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                disableFuture
                autoOk
                fullWidth
                variant="inline"
                format="MM/dd/yyyy"
                emptyLabel="mm/dd/yyyy"
                name="created_from"
                label="From"
                className="mt-5"
                value={
                  conditions?.created_from?.value
                    ? setConvertedDate(conditions.created_from.value)
                    : null
                }
                onChange={(date) => handleChangeFilter(
                  'created_at',
                  `${format(date, 'yyyy-MM-dd 00:00:00')}`,
                  'gt',
                  'created_from'
                )
                }
                inputVariant="outlined"
                clearable
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <CalendarTodayIcon className="text-muted text-16" />
                  ),
                  endAdornment: (
                    <Icon
                      className="cursor-pointer"
                      onClick={(event) => handleClearDate(event, 'created_from')}
                    >
                      close
                    </Icon>
                  )
                }}
              />
              <DatePicker
                disableFuture
                autoOk
                fullWidth
                variant="inline"
                format="MM/dd/yyyy"
                emptyLabel="mm/dd/yyyy"
                name="created_to"
                label="To"
                className="mt-5"
                value={
                  conditions?.created_to?.value
                    ? setConvertedDate(conditions.created_to.value)
                    : null
                }
                onChange={(date) => handleChangeFilter(
                  'created_at',
                  `${format(date, 'yyyy-MM-dd 23:59:59')}`,
                  'lt',
                  'created_to'
                )
                }
                inputVariant="outlined"
                clearable
                InputProps={{
                  readOnly: true,
                  startAdornment: (
                    <CalendarTodayIcon className="text-muted text-16" />
                  ),
                  endAdornment: (
                    <Icon
                      className="cursor-pointer"
                      onClick={(event) => handleClearDate(event, 'created_to')}
                    >
                      close
                    </Icon>
                  )
                }}
                error={isCreateAtError}
                helperText={
                  isCreateAtError
                  && '“From” Date can not be later than “To” Date'
                }
              />
            </MuiPickersUtilsProvider>
          </Collapse>
        </div>
      </div>
      <div className="flex items-center justify-between pb-4">
        <Button
          variant="contained"
          color="primary"
          fullWidth
          className="mr-2 uppercase"
          onClick={handleApplyFilter}
          disabled={isCreateAtError}
        >
          Apply Filters
        </Button>
        <Button
          variant="outlined"
          fullWidth
          className="uppercase"
          onClick={() => {
            setFilterConditions({});
            setOpenFilter(false);
          }}
        >
          Reset
        </Button>
      </div>
    </div>
  );
};

export default HistoryFilterDrawer;
